import React, { useState } from "react";
import UserDropdown from "./UserDropdown";
import Button from "../../components/form/Button";
import LogoutModal from "../../components/common/LogoutModal";
import MyProfile from "../../pages/front/profile/MyProfile";
import FrontPasswordChange from "../../pages/front/profile/FrontPasswordChange";
import Image from "../../components/elements/Image";
import Indentification from "../../components/elements/Indentification";
import { initialsValue } from "../../helpers";

const AdminHeader = ({ profile }) => {
  const data = {
    image: profile?.image?.url,
    name: profile?.firstName
      ? profile?.firstName + " " + profile?.lastName
      : "Admin",
    email: profile?.email || "admin123@gmail.com",
  };

  return (
    <>
      <header className="relative h-16 z-50 w-full flex py-2 px-3 border-t border-shades-05/25">
        <div className="relative flex items-center gap-1 w-full">
          <div className="flex-shrink flex-grow mr-auto">
            <div className="flex items-center gap-2">
              {!data?.image || !!data?.image?.url ? (
                <div className="flex items-center justify-center bg-catskill-white text-chestnut-rose rounded-full w-7 md:w-8 h-7 md:h-8">
                  <i className="fa-regular fa-user" />
                </div>
              ) : (
                <Indentification initial={initialsValue(data?.name)} />
              )}
              <div className={`text-[13px] font-medium text-gable-green line-clamp-3 break-all break-words`}>{data?.name}</div>
            </div>
          </div>
          <div className="flex-shrink-0 flex items-center gap-1 ml-auto">
            <UserDropdown data={data} role={profile?.roleCode} xPlacement={"topRight"} />
          </div>
        </div>
      </header>
    </>
  );
};

export default AdminHeader;
